(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dama-instagram-feed"] && !Shopify.designMode) return;
  try {
    (() => {
  const safeLink = value => {
    try {
      const url = new URL(value);
      return url.protocol === 'https:' && url.hostname === 'www.instagram.com' && /^\/(p|reel|tv)\/[A-Za-z0-9_-]+\/$/.test(url.pathname) && !url.search && !url.hash && !url.username && !url.password && !url.port;
    } catch { return false; }
  };
  async function mount(section) {
    if (section.dataset.feedLoading === 'true') return;
    const grid = section.querySelector('.dama-instagram__grid');
    if (!grid || !section.dataset.instagramFeed) return;
    let endpoint;
    try { endpoint = new URL(section.dataset.instagramFeed); } catch { return; }
    if (endpoint.protocol !== 'https:' || endpoint.pathname !== '/v1/instagram/feed' || endpoint.search || endpoint.hash || endpoint.username || endpoint.password) return;
    section.dataset.feedLoading = 'true';
    const controller = new AbortController(); const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(endpoint.href, { signal: controller.signal, credentials: 'omit', referrerPolicy: 'no-referrer', cache: 'no-store' });
      if (!response.ok) throw new Error('Feed unavailable');
      const data = await response.json();
      if (data.version !== 1 || data.username !== 'dama_couture' || !Array.isArray(data.items) || data.items.length > 5) throw new Error('Invalid feed');
      const ids = new Set(); const fragment = document.createDocumentFragment(); const loads = [];
      for (const item of data.items) {
        if (!/^\d+$/.test(item.id) || ids.has(item.id) || !safeLink(item.permalink) || !new RegExp('^/v1/instagram/images/' + item.id + '/[a-f0-9]{64}$').test(item.imagePath)) throw new Error('Invalid item');
        ids.add(item.id);
        const link = document.createElement('a'); link.href = item.permalink; link.target = '_blank'; link.rel = 'noopener noreferrer';
        link.setAttribute('aria-label', section.dataset.instagramLabel || 'Instagram DAMA Couture');
        const image = document.createElement('img'); image.alt = ''; image.width = 480; image.height = 480; image.decoding = 'async'; image.referrerPolicy = 'no-referrer';
        image.src = new URL(item.imagePath, endpoint.origin).href;
        loads.push(image.decode().then(() => {
          image.width = image.naturalWidth; image.height = image.naturalHeight;
          link.style.setProperty('--dama-instagram-ratio', image.naturalWidth / image.naturalHeight);
        }));
        link.append(image); fragment.append(link);
      }
      if (controller.signal.aborted) throw new Error('Timeout');
      await Promise.race([Promise.all(loads), new Promise((_, reject) => controller.signal.addEventListener('abort', () => reject(new Error('Timeout')), { once: true }))]);
      if (!section.isConnected || controller.signal.aborted) return;
      grid.replaceChildren(fragment); grid.hidden = data.items.length === 0;
      section.dataset.feedState = data.stale ? 'stale' : 'ready';
    } catch {
      if (!grid.children.length) grid.hidden = true;
      section.dataset.feedState = 'unavailable';
    } finally { clearTimeout(timeout); delete section.dataset.feedLoading; }
  }
  function start(root) {
    root.querySelectorAll('[data-instagram-feed]').forEach(section => {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); mount(section); }
        }, { rootMargin: '300px' }); observer.observe(section);
      } else mount(section);
    });
  }
  start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
